import script from "./AvatarsActivity.vue?vue&type=script&setup=true&lang=ts"
export * from "./AvatarsActivity.vue?vue&type=script&setup=true&lang=ts"

import "./AvatarsActivity.vue?vue&type=style&index=0&id=28a4164e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28a4164e"]])

export default __exports__